module.exports = __webpack_public_path__ + "img/bg_index_teacher_02_new.8c030c11.png";